/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import TextFeild from "../../components/CommonComponents/TextFeild";
import StyledLogin from "./StyledLogin";
import { BUTTON_LABELS, INPUT_LABELS } from "../../constants/lang";
import { ROUTE_PATH } from "../../constants/route";
import { loginSchema } from "../../schema/loginSchema";
import { fetchLogin, fetchStatusColors } from "../../store/reducers/authentication/apiThunk";
import {
  ToastNotifyError,
} from "../../components/CommonComponents/Toast/ToastNotify";
import {
  // logout,
  // selectorAuthentication,
  setReduxRememberMe,
} from "../../store/reducers/authentication";
import { fetchSellerProfile } from "../../store/reducers/createProfile/apithunk";
import rollbar from "../../rollbarConfig";

const { SIGNUP, FORGET_PASSWORD, SIGNUP_REGISTRATIONS_EXISTS } = ROUTE_PATH;

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setLoading] = useState(false);
  // const authState = useSelector(selectorAuthentication);
  
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  // useEffect(() => {
  //   const token = authState?.auth?.data?.data?.auth_token;
  //   if (token) {
  //     navigate(ROUTE_PATH.CREATE_PROFILE);
  //   } else if (!token) {
  //     dispatch(logout());
  //   }
  // }, []);

  const getColorStatus = async () => {
    try {
      const res = await dispatch(fetchStatusColors());
      const {status, message } = res?.payload;
      if (status) {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
      } else {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
        ToastNotifyError("message", message);
      }
    } catch (error) {
      console.error("Login failed:", error);
      rollbar.error("Error message", error);
    }
  };

  const onSubmit = async ({ email = "", password = "" }) => {
    setLoading(true);
    const dataToSend = {
      email: email,
      password: password,
    };
    try {
      const response = await dispatch(fetchLogin(dataToSend));
      const { status, message, data: {data : {user_type}} = {} } = response?.payload;
      if(user_type !== "S"){
        ToastNotifyError("This account is registered as a buyer. Please log in as a buyer");
        return;
      }
      if (status === 200) {
        if (rememberMe) {
          dispatch(setReduxRememberMe(true));
        } else {
          dispatch(setReduxRememberMe(false));
        }
        reset();
        try{
          const res = await dispatch((fetchSellerProfile()));
          const { step } = res?.payload?.data || {};
          if(step === 3){
            getColorStatus();
          } else {
            navigate(ROUTE_PATH.CREATE_PROFILE);
          }
        } catch(err){
          console.log("err :", err)
          rollbar.error("Error message", err);
        }
      } else if (status === 403) {
        if (rememberMe) {
          dispatch(setReduxRememberMe(true));
        } else {
          dispatch(setReduxRememberMe(false));
        }
        reset();
        navigate(SIGNUP_REGISTRATIONS_EXISTS);
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Login failed:", error);
      rollbar.error("Error message", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowPassword = (e) => {
    setShowPassword(e);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <StyledLogin>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        className="login-wrap"
      >
        <Typography className="login-header">Login</Typography>
        <Typography className="login-sub-header">
          Log in to view your dashboard, manage your inventory, and track
          orders.
        </Typography>
        <Box className="login-textfeilds">
          <Box className="login-email">
            <Controller
              name="email"
              control={control}
              className="email-feild"
              defaultValue=""
              render={({ field }) => (
                <TextFeild
                  {...field}
                  required
                  label={INPUT_LABELS.email}
                  placeholder="Enter your email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              )}
            />
          </Box>
          <Box className="password">
            <Controller
              name="password"
              control={control}
              defaultValue=""
              className="password-feild"
              render={({ field }) => (
                <TextFeild
                  {...field}
                  required
                  label={INPUT_LABELS.password}
                  placeholder="Enter your password"
                  type="password"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  show={showPassword}
                  isShow={handleShowPassword}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                />
              )}
            />
          </Box>
          <Box className="checkbox-wrap">
            <Controller
              name="agreeToTerms"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={rememberMe}
                      onChange={handleRememberMeChange}
                      color="primary"
                      aria-label="rememberMe-checkbox"
                    />
                  }
                  label={<Box className="terms-condition">Remember Me</Box>}
                />
              )}
            />
            <Link to={FORGET_PASSWORD} aria-label="forgetpass">
              Forgot password?
            </Link>
          </Box>
        </Box>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          isLoading={isLoading}
          disabled={isLoading}
          aria-label="submit-btn"
          className="submit-btn"
        >
          {BUTTON_LABELS.LOGIN}
        </Button>
        <Box className="login">
          <Typography>
            Don’t have an account?
            <Link to={SIGNUP} aria-label="Signup">
              Sign up
            </Link>
          </Typography>
        </Box>
      </Box>
    </StyledLogin>
  );
};

export default LoginForm;
